// Read server-calculated ex-VAT amounts. Never turn a configured fee into a charge.
const pennies = (value, fallback = 0) =>
  Number.isSafeInteger(value) && value >= 0 ? value : fallback

export const deliveryFeeDisplay = (supplier = {}) => {
  const saved = supplier.orderFinancialSnapshot || supplier
  const goods = pennies(
    saved.goodsSubtotalPennies,
    Math.round((supplier.subtotal || 0) * 100),
  )
  const delivery = pennies(saved.appliedDeliveryFeePennies)
  const minimum = pennies(
    saved.minOrderValuePennies,
    pennies(supplier.minOrderValue),
  )
  const configured = pennies(
    saved.configuredDeliveryFeePennies,
    pennies(supplier.deliveryFee),
  )
  const remaining = Math.max(0, minimum - goods)
  const canOrder =
    typeof supplier.canOrder === 'boolean'
      ? supplier.canOrder
      : remaining === 0 || configured > 0
  let message = ''
  if (!canOrder) {
    message = `Minimum order is £${(minimum / 100).toFixed(2)}. Add another £${(
      remaining / 100
    ).toFixed(2)} of products to continue.`
  } else if (remaining > 0) {
    message =
      delivery > 0
        ? `Below the £${(minimum / 100).toFixed(2)} minimum. Add another £${(
            remaining / 100
          ).toFixed(2)} of products and delivery is included.`
        : `Add another £${(remaining / 100).toFixed(
            2,
          )} of products to reach the £${(minimum / 100).toFixed(2)} minimum.`
  }
  return {
    goods: goods / 100,
    delivery: delivery / 100,
    total: pennies(saved.orderTotalPennies, goods + delivery) / 100,
    canOrder,
    message,
  }
}

export const selectedDeliveryTotals = (suppliers = [], selectedIds) => {
  const selected = suppliers.filter(
    s => !selectedIds || selectedIds.has(s.supplierId),
  )
  const totals = selected.reduce(
    (sum, supplier) => {
      const amounts = deliveryFeeDisplay(supplier)
      return {
        goods: sum.goods + Math.round(amounts.goods * 100),
        delivery: sum.delivery + Math.round(amounts.delivery * 100),
        total: sum.total + Math.round(amounts.total * 100),
      }
    },
    { goods: 0, delivery: 0, total: 0 },
  )
  return {
    goods: totals.goods / 100,
    delivery: totals.delivery / 100,
    total: totals.total / 100,
  }
}

// A locally edited or shared basket must match the reviewed server preview.
export const matchesDeliveryPreview = (orders, summary) => {
  const signature = lines =>
    lines
      .map(([id, quantity]) => `${id}:${Number(quantity)}`)
      .sort()
      .join('|')
  return (
    Array.isArray(summary?.suppliers) &&
    signature(orders.map(o => [o._id, o.quantity])) ===
      signature(
        summary.suppliers.flatMap(s =>
          s.items.map(i => [i.orderId, i.quantity]),
        ),
      )
  )
}
